export const PUBLICO = 1;
export const PRIVADO = 2;
